import { useRef, useState, useEffect } from 'react'

function calculateDimensions(ref) {
  return ref.current
    ? ref.current.getBoundingClientRect()
    : { width: 0, height: 0 }
}

export const useDimensions = () => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const dimensionsRef = useRef()

  const { width, height } = calculateDimensions(dimensionsRef)
  useEffect(() => {
    setDimensions({ width, height })
  }, [height, width])

  return {
    width: dimensions.width,
    height: dimensions.height,
    dimensionsRef
  }
}
